'use client'
const requiresPasswordForEmbeddedWallet = (projectSettings) => {
    var _a, _b;
    const embeddedWalletsPasswordSettings = (_b = (_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk.embeddedWallets) === null || _a === void 0 ? void 0 : _a.supportedSecurityMethods) === null || _b === void 0 ? void 0 : _b.password;
    if (!embeddedWalletsPasswordSettings) {
        return false;
    }
    return (embeddedWalletsPasswordSettings.isEnabled &&
        embeddedWalletsPasswordSettings.isDefault);
};

export { requiresPasswordForEmbeddedWallet };
